import React from 'react';
import { ArticleHeading2, ArticleHeading3 } from '@cian/ui-kit';
import { TDeviceType } from '@cian/ui-kit/responsive';
import cn from 'classnames';

import { ClientTypeToggle } from '../../packages/ClientTypeToggle';
import { NBSP } from '../../constants/symbols';
import { trackNavigateToBClientPromo } from './tracking';

import * as styles from './styles.css';

export const CustomerRoleSection: React.FC<{
  deviceType: TDeviceType;
  b2bPromoUrl: string;
}> = ({ b2bPromoUrl, deviceType }) => {
  const isMobile = deviceType === 'phone';
  const TitleComponent = isMobile ? ArticleHeading3 : ArticleHeading2;

  return (
    <section className={styles['section']}>
      <div className={cn(styles['wrapper'], styles[deviceType])}>
        <TitleComponent color="black_100">
          В какой роли вы участвуете{NBSP}в{NBSP}сделке?
        </TitleComponent>
        <ClientTypeToggle
          activeText={isMobile ? 'Я покупатель/продавец' : 'Я покупатель / продавец'}
          activeIconX1="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/c_client_icon_x1.png"
          activeIconX2="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/c_client_icon_x2.png"
          inactiveText={isMobile ? 'Я риелтор' : 'Веду сделку как риелтор'}
          inactiveIconX1="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/b_client_icon_x1.png"
          inactiveIconX2="https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/b_client_icon_x2.png"
          inactiveLinkHref={b2bPromoUrl}
          onLinkClick={trackNavigateToBClientPromo}
        />
      </div>
    </section>
  );
};
